import { useMemo } from "react";

import moment from "moment";

import { Calendar, ButtonGroup } from "@components/v2";
import { useUniversalBenchmarksConfiguratorContext } from "@features/universal-benchmarks/configurator/hooks";

import { DATE_RANGE_CHOICES } from "../constants";

export const SelectBaselineDays = () => {
  const {
    baselineFilters,
    isBaselineDaysLoading,
    metadata,
    setBaselineFilters,
  } = useUniversalBenchmarksConfiguratorContext();

  const dateRangeOptions = useMemo(() => {
    return DATE_RANGE_CHOICES.map((e) => {
      const minDate = metadata.minDate ? moment(metadata.minDate) : moment();
      const startRange = moment().subtract(e.amount, e.unit);

      return {
        value: e.value,
        label:
          e.value === "custom" ? (
            <i className="fa-regular fa-calendar-range" />
          ) : (
            e.label
          ),
        disabled: minDate.isSameOrAfter(startRange),
        className: e.className,
      };
    });
  }, [metadata.minDate]);

  return (
    <div className="py-6 pl-6 pr-3">
      <h3 className="text-base font-semibold">Select baseline days</h3>
      <p className="text-sm text-v2-secondary">
        Pick a date range from which to calculate your benchmark. Choose the
        longest range that reflects your current marketing strategy. For
        example, if you changed strategies 6 months ago, use data from that
        period to ensure your benchmark matches where you're headed.
      </p>
      <div className="my-4">
        <ButtonGroup
          disabled={isBaselineDaysLoading}
          value={
            typeof baselineFilters.dateRange === "string"
              ? baselineFilters.dateRange
              : "custom"
          }
          options={dateRangeOptions}
          onChange={(value) => {
            if (value === "custom") {
              const custom = DATE_RANGE_CHOICES.find(
                (e) => e.value === "custom",
              )!;

              setBaselineFilters({
                ...baselineFilters,
                dateRange: {
                  startDate: moment()
                    .subtract(custom.amount, custom.unit)
                    .format("YYYY-MM-DD"),
                  endDate: moment().subtract(1, "day").format("YYYY-MM-DD"),
                  type: "fixed",
                },
              });
            } else {
              setBaselineFilters({ ...baselineFilters, dateRange: value });
            }
          }}
        />
      </div>
      {typeof baselineFilters.dateRange !== "string" && (
        <div className="border border-v2-tertiary rounded-md text-sm p-3">
          <Calendar
            variant="benchmarks"
            disabled={isBaselineDaysLoading}
            minDate={metadata.minDate ?? moment().format("YYYY-MM-DD")}
            maxDate={moment().format()}
            value={baselineFilters.dateRange}
            onChange={(value) =>
              setBaselineFilters({
                ...baselineFilters,
                dateRange: { ...value, type: "fixed" },
              })
            }
          />
        </div>
      )}
    </div>
  );
};
